import React from 'react';
import { PORTAL_HEADER_CSS_VAR } from './PortalUemHeader';

export default function TitledPageShell({ title, description, children }) {
  const contentPt = `calc(var(${PORTAL_HEADER_CSS_VAR}, 160px) + 16px)`;

  return (
    <div className="w-full" style={{ paddingTop: contentPt }}>
      <div className="mx-auto w-full max-w-[1400px] px-3 md:px-6 2xl:px-0">
        <div className="py-1.5 md:py-2">
          <div className="text-2xl font-bold tracking-tight text-gray-900 md:text-3xl">{title}</div>
          {description ? (
            <>
              <div className="mt-1 h-[2px] w-full bg-gray-200" />
              <div className="mt-1 whitespace-pre-line text-left text-base leading-7 text-gray-600 md:text-lg">
                {description}
              </div>
              <div className="mt-1.5 h-[2px] w-full bg-gray-100" />
            </>
          ) : null}
        </div>

        {children}
      </div>
    </div>
  );
}

